import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';

const Prompt = ({
	onConfirm,
	onClose,
	promptHeaderText,
	promptSubHeaderText,
	promptYesButtonText,
	promptNoButtonText,
}) => (
	<div>
		<h2>{promptHeaderText}</h2>

		<p>{promptSubHeaderText}</p>
		<ButtonGroup>
			<Button id="prompt-yes-button" display="primary" width="full" onClick={onConfirm}>
				{promptYesButtonText}
			</Button>
			<Button id="prompt-no-button" display="secondary" width="full" onClick={onClose}>
				{promptNoButtonText}
			</Button>
		</ButtonGroup>
	</div>
);

Prompt.propTypes = {
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	promptHeaderText: PropTypes.string.isRequired,
	promptSubHeaderText: PropTypes.string.isRequired,
	promptYesButtonText: PropTypes.string.isRequired,
	promptNoButtonText: PropTypes.string.isRequired,
};

export default Prompt;
